import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./style.css";

import heroImage from "../../assets/images/home/bg-home.jpg";
import iconDiagnosis from "../../assets/images/home/diagnosis.png";
import iconAnalysis from "../../assets/images/home/blood-test.png";
import iconSupport from "../../assets/images/home/maintenance.png";
import homeAbout from "../../assets/images/logo.png";

export const Home = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const toggleAnswer = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqItems = [
    {
      question: t("faq.q1"),
      answer: t("faq.a1"),
    },
    {
      question: t("faq.q2"),
      answer: t("faq.a2"),
    },
    {
      question: t("faq.q3"),
      answer: t("faq.a3"),
    }
  ];

  const onClick = () => {
    navigate('/activities');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="homepage">
      <div className="hero">
        <img src={heroImage} alt={t("alt.hero")} className="hero-image" />
        <div className="hero-text">
          <h1>{t("heroTitle")}</h1>
          <p>{t("hero.subtitle")}</p>
        </div>
      </div>

      <div className="home-about">
        <div className="home-about-img">
          <img src={homeAbout} alt={t("alt.about")} />
        </div>

        <div className="home-about-content">
          <h1>{t("about.welcomeTitle")}</h1>
          <h4>{t("about.subtitle")}</h4>
          <p>{t("about.p1")}</p>
          <p>{t("about.p2")}</p>
          <h4>{t("about.missionTitle")}</h4>
          <p>{t("about.p3")}</p>
        </div>
      </div>

      <div className="home-info">
        <div>
          <h2>{t("info.title")}</h2>
          <button onClick={onClick}>{t("info.button")}</button>
        </div>
      </div>

      <div className="home-services">
        <h2>{t("services.title")}</h2>
        <div className="home-services-list">
          <div className="home-services-item">
            <img src={iconDiagnosis} alt={t("alt.diagnosis")} className="home-services-icon" />
            <h3>{t("services.diagnosis.title")}</h3>
            <p>{t("services.diagnosis.desc")}</p>
          </div>
          <div className="home-services-item">
            <img src={iconAnalysis} alt={t("alt.analysis")} className="home-services-icon" />
            <h3>{t("services.analysis.title")}</h3>
            <p>{t("services.analysis.desc")}</p>
          </div>
          <div className="home-services-item">
            <img src={iconSupport} alt={t("alt.support")} className="home-services-icon" />
            <h3>{t("services.support.title")}</h3>
            <p>{t("services.support.desc")}</p>
          </div>
        </div>
      </div>

      <div className="faq">
        <h2>{t("faq.title")}</h2>
        <div className="faq-list">
          {faqItems.map((item, index) => (
            <div className="faq-item" key={index}>
              <h3 onClick={() => toggleAnswer(index)}>{item.question}</h3>
              <p style={{ display: activeIndex === index ? 'block' : 'none' }}>{item.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
